import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import collaborationApi from "../../../api/collaborationApi";

const CollabReport = ({ collabId }) => {
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Get collabId from query params
  // const queryParams = new URLSearchParams(location.search);
  // const collabId = queryParams.get("collabId");

  useEffect(() => {
    if (collabId) {
      collaborationApi
        .getCollabReport(collabId)
        .then((res) => {
          const data = Array.isArray(res.data) ? res.data : [];
          setReport(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching report:", err);
          setLoading(false);
        });
    }
  }, [collabId]);

  if (loading) return <div>Loading report...</div>;

  return (
    <>
      <br />
      <h4 className="mb-2">
        <strong>Collaboration Report</strong>
      </h4>

      <div style={{ overflowX: "auto", width: "100%" }}>
        <Table
          striped
          bordered
          hover
          style={{ minWidth: "1100px", whiteSpace: "nowrap" }}
          className="mt-4"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Action</th>
              <th>Checklist Item/Document Name</th>
              <th>Status</th>
              <th>Assigned To</th>
              <th>Added By</th>
              {/* <th>Document Name</th> */}
              <th>Sent To</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {report.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.action}</td>
                <td>{item.checklistItem || item.documentName || "-"}</td>
                <td>
                  {item.documentName
                    ? "Done"
                    : item.checklistStatus !== undefined
                      ? item.checklistStatus
                        ? "Done"
                        : "Pending"
                      : "-"}
                </td>
                <td>
                  {" "}
                  {item.email}-{item.checklistAssignedTo || "-"}
                </td>
                <td>{item.checklistAddedBy || item.uploadedBy || "-"}</td>
                {/* <td>{item.documentName || "-"}</td> */}
                <td>
                  {item.sentToEmails?.join(", ") || "-"}-{item.sendTo}
                </td>
                <td>{item.uploadAt || item.checklistDeadline || "-"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default CollabReport;
